/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Create_DescriptionInputs */



/**
* | output |
* | --- |
* | "Create a new shared space for storing files with teams and users." |
*
* @param {Spaces_Create_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_create_description = /** @type {((inputs?: Spaces_Create_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Create_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstelle einen neuen gemeinsamen Space zum Speichern von Dateien mit Teams und Benutzern.")
	return /** @type {LocalizedString} */ ("Create a new shared space for storing files with teams and users.")
});